import { useEffect, useState } from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { supabase } from "@/lib/supabase";

// --- MEGA MENU VERI YAPISI ---
const MEGA_MENU_DATA: { [key: string]: any } = {
  kadin: {
    textColumns: [
      {
        title: "Giyim",
        items: [
          { label: "Elbise", value: "kadin-elbise" },
          { label: "Tisort", value: "kadin-tisort" },
          { label: "Gomlek & Bluz", value: "kadin-gomlek" },
          { label: "Sweatshirt", value: "kadin-sweat" },
          { label: "Kazak & Hirka", value: "kadin-kazak" },
          { label: "Mont & Kaban", value: "kadin-mont" },
          { label: "Pantolon", value: "kadin-pantolon" },
          { label: "Jean", value: "kadin-jean" },
          { label: "Etek", value: "kadin-etek" },
          { label: "Triko", value: "kadin-triko" },
          { label: "Ic Giyim", value: "kadin-ic-giyim" },
          { label: "Pijama & Ev Giyim", value: "kadin-pijama" },
          { label: "Spor Giyim", value: "kadin-spor-giyim" },
          { label: "Tesettur Giyim", value: "kadin-tesettur" },
          { label: "Buyuk Beden", value: "kadin-buyuk-beden" },
        ],
      },
      {
        title: "Ayakkabi",
        items: [
          { label: "Spor Ayakkabi", value: "kadin-spor-ayakkabi" },
          { label: "Sneaker", value: "kadin-sneaker" },
          { label: "Topuklu Ayakkabi", value: "kadin-topuklu" },
          { label: "Bot & Cizme", value: "kadin-bot" },
          { label: "Sandalet", value: "kadin-sandalet" },
          { label: "Babet", value: "kadin-babet" },
          { label: "Terlik", value: "kadin-terlik" },
          { label: "Loafer", value: "kadin-loafer" },
          { label: "Kosu Ayakkabisi", value: "kadin-kosu" },
        ],
      },
      {
        title: "Aksesuar & Taki",
        items: [
          { label: "Canta", value: "kadin-canta" },
          { label: "Saat", value: "kadin-saat" },
          { label: "Taki & Bijuteri", value: "kadin-taki" },
          { label: "Gunes Gozlugu", value: "kadin-gozluk" },
          { label: "Sal & Esarp", value: "kadin-sal" },
          { label: "Kemer", value: "kadin-kemer" },
          { label: "Sapka & Bere", value: "kadin-sapka" },
          { label: "Cuzdan", value: "kadin-cuzdan" },
        ],
      },
    ],
    promoCards: [
      { label: "KADIN AYAKKABI", image: "https://images.unsplash.com/photo-1543163521-1bf539c55dd2?w=300&h=200&fit=crop", link: "kadin-spor-ayakkabi" },
      { label: "KADIN CANTA", image: "https://images.unsplash.com/photo-1584917865442-de89df76afd3?w=300&h=200&fit=crop", link: "kadin-canta" },
      { label: "YAZ ELBISELERI", image: "https://images.unsplash.com/photo-1572804013309-59a88b7e92f1?w=300&h=200&fit=crop", link: "kadin-elbise", highlight: true },
      { label: "SNEAKER", image: "https://images.unsplash.com/photo-1595950653106-6c9ebd614d3a?w=300&h=200&fit=crop", link: "kadin-sneaker" },
      { label: "GUNES GOZLUKLERI", image: "https://images.unsplash.com/photo-1511499767150-a48a237f0083?w=300&h=200&fit=crop", link: "kadin-gozluk" },
      { label: "TAKI & BIJUTERI", image: "https://images.unsplash.com/photo-1515562141589-67f0d1c3c507?w=300&h=200&fit=crop", link: "kadin-taki" },
    ],
  },
  erkek: {
    textColumns: [
      {
        title: "Giyim",
        items: [
          { label: "Tisort", value: "erkek-tisort" },
          { label: "Gomlek", value: "erkek-gomlek" },
          { label: "Sweatshirt", value: "erkek-sweat" },
          { label: "Kazak", value: "erkek-kazak" },
          { label: "Mont & Kaban", value: "erkek-mont" },
          { label: "Pantolon", value: "erkek-pantolon" },
          { label: "Jean", value: "erkek-jean" },
          { label: "Ceket", value: "erkek-ceket" },
          { label: "Takim Elbise", value: "erkek-takim" },
          { label: "Sort", value: "erkek-sort" },
          { label: "Esofman", value: "erkek-esofman" },
          { label: "Polo Tisort", value: "erkek-polo" },
          { label: "Ic Giyim", value: "erkek-ic-giyim" },
          { label: "Pijama & Ev Giyim", value: "erkek-pijama" },
        ],
      },
      {
        title: "Ayakkabi",
        items: [
          { label: "Spor Ayakkabi", value: "erkek-spor-ayakkabi" },
          { label: "Sneaker", value: "erkek-sneaker" },
          { label: "Gunluk Ayakkabi", value: "erkek-gunluk" },
          { label: "Bot", value: "erkek-bot" },
          { label: "Klasik Ayakkabi", value: "erkek-klasik" },
          { label: "Kosu Ayakkabisi", value: "erkek-kosu" },
          { label: "Terlik & Sandalet", value: "erkek-terlik" },
          { label: "Outdoor Ayakkabi", value: "erkek-outdoor-ayakkabi" },
        ],
      },
      {
        title: "Aksesuar",
        items: [
          { label: "Saat", value: "erkek-saat" },
          { label: "Gunes Gozlugu", value: "erkek-gozluk" },
          { label: "Kemer & Cuzdan", value: "erkek-aksesuar" },
          { label: "Canta & Sirt Cantasi", value: "erkek-canta" },
          { label: "Kravat & Papyon", value: "erkek-kravat" },
          { label: "Sapka", value: "erkek-sapka" },
          { label: "Atkisi & Bere", value: "erkek-atki" },
        ],
      },
    ],
    promoCards: [
      { label: "ERKEK AYAKKABI", image: "https://images.unsplash.com/photo-1542291026-7eec264c27ff?w=300&h=200&fit=crop", link: "erkek-spor-ayakkabi" },
      { label: "ERKEK CANTA", image: "https://images.unsplash.com/photo-1553062407-98eeb64c6a62?w=300&h=200&fit=crop", link: "erkek-canta" },
      { label: "SNEAKER KOLEKSIYONU", image: "https://images.unsplash.com/photo-1608231387042-66d1773070a5?w=300&h=200&fit=crop", link: "erkek-sneaker", highlight: true },
      { label: "SAAT", image: "https://images.unsplash.com/photo-1524805444758-089113d48a6d?w=300&h=200&fit=crop", link: "erkek-saat" },
      { label: "JEAN & PANTOLON", image: "https://images.unsplash.com/photo-1542272604-787c3835535d?w=300&h=200&fit=crop", link: "erkek-jean" },
      { label: "MONT & KABAN", image: "https://images.unsplash.com/photo-1591047139829-d91aecb6caea?w=300&h=200&fit=crop", link: "erkek-mont" },
    ],
  },
  elektronik: {
    textColumns: [
      {
        title: "Telefon & Aksesuar",
        items: [
          { label: "Cep Telefonu", value: "cep-telefonu" },
          { label: "Bluetooth Kulaklik", value: "bluetooth-kulaklik" },
          { label: "Akilli Saat", value: "akilli-saat" },
          { label: "Powerbank", value: "powerbank" },
          { label: "Sarj Cihazlari", value: "sarj-cihazi" },
          { label: "Telefon Kilifi", value: "telefon-kilifi" },
          { label: "Ekran Koruyucu", value: "ekran-koruyucu" },
          { label: "Kablolar", value: "kablolar" },
          { label: "Arac Ici Aksesuar", value: "arac-ici" },
        ],
      },
      {
        title: "Bilgisayar & Tablet",
        items: [
          { label: "Laptop", value: "laptop" },
          { label: "Tablet", value: "tablet" },
          { label: "Monitor", value: "monitor" },
          { label: "Mouse & Klavye", value: "bilgisayar-aksesuar" },
          { label: "Oyuncu Ekipmanlari", value: "oyuncu" },
          { label: "Gaming Laptop", value: "gaming-laptop" },
          { label: "Yazici", value: "yazici" },
          { label: "Harici Disk & SSD", value: "harici-disk" },
          { label: "Ram & Bellek", value: "ram" },
        ],
      },
      {
        title: "Ev Elektronigi",
        items: [
          { label: "Televizyon", value: "televizyon" },
          { label: "Ses Sistemleri", value: "ses-sistemleri" },
          { label: "Robot Supurge", value: "robot-supurge" },
          { label: "Kahve Makinesi", value: "kahve-makinesi" },
          { label: "Airfryer", value: "airfryer" },
          { label: "Dikey Supurge", value: "supurge" },
          { label: "Utu", value: "utu" },
          { label: "Klima", value: "klima" },
          { label: "Projeksiyon", value: "projeksiyon" },
        ],
      },
    ],
    promoCards: [
      { label: "CEP TELEFONLARI", image: "https://images.unsplash.com/photo-1511707171634-5f897ff02aa9?w=300&h=200&fit=crop", link: "cep-telefonu" },
      { label: "LAPTOPLAR", image: "https://images.unsplash.com/photo-1496181133206-80ce9b88a853?w=300&h=200&fit=crop", link: "laptop" },
      { label: "AKILLI SAAT", image: "https://images.unsplash.com/photo-1546868871-af0de0ae72be?w=300&h=200&fit=crop", link: "akilli-saat" },
      { label: "KULAKLIKLAR", image: "https://images.unsplash.com/photo-1590658268037-6bf12f032f55?w=300&h=200&fit=crop", link: "bluetooth-kulaklik", highlight: true },
      { label: "TV & SES SISTEMLERI", image: "https://images.unsplash.com/photo-1593784991095-a205069470b6?w=300&h=200&fit=crop", link: "televizyon" },
      { label: "ROBOT SUPURGE", image: "https://images.unsplash.com/photo-1558618666-fcd25c85f82e?w=300&h=200&fit=crop", link: "robot-supurge" },
    ],
  },
  "anne-cocuk": {
    textColumns: [
      {
        title: "Bebek",
        items: [
          { label: "Bebek Giyim", value: "bebek-giyim" },
          { label: "Bebek Ayakkabi", value: "bebek-ayakkabi" },
          { label: "Bebek Bakim", value: "bebek-bakim" },
          { label: "Bebek Bezi", value: "bebek-bezi" },
          { label: "Biberon & Emzik", value: "biberon" },
          { label: "Mama Sandalyesi", value: "mama-sandalyesi" },
          { label: "Bebek Arabasi", value: "bebek-arabasi" },
          { label: "Oto Koltugu", value: "oto-koltugu" },
          { label: "Bebek Yatagi", value: "bebek-yatagi" },
        ],
      },
      {
        title: "Cocuk",
        items: [
          { label: "Kiz Cocuk Giyim", value: "kiz-cocuk" },
          { label: "Erkek Cocuk Giyim", value: "erkek-cocuk" },
          { label: "Cocuk Ayakkabi", value: "cocuk-ayakkabi" },
          { label: "Okul Ekipmanlari", value: "okul" },
          { label: "Cocuk Aksesuar", value: "cocuk-aksesuar" },
        ],
      },
      {
        title: "Oyuncak & Anne",
        items: [
          { label: "Oyuncak", value: "oyuncak" },
          { label: "Lego & Yapboz", value: "lego" },
          { label: "Akulu Araclar", value: "akulu-arac" },
          { label: "Hamile Giyim", value: "hamile-giyim" },
          { label: "Anne Bakim", value: "anne-bakim" },
          { label: "Emzirme Urunleri", value: "emzirme" },
        ],
      },
    ],
    promoCards: [
      { label: "BEBEK GIYIM", image: "https://images.unsplash.com/photo-1522771930-78848d9293e8?w=300&h=200&fit=crop", link: "bebek-giyim" },
      { label: "OYUNCAKLAR", image: "https://images.unsplash.com/photo-1558060370-d644479cb6f7?w=300&h=200&fit=crop", link: "oyuncak", highlight: true },
      { label: "COCUK GIYIM", image: "https://images.unsplash.com/photo-1503454537195-1dcabb73ffb9?w=300&h=200&fit=crop", link: "kiz-cocuk" },
      { label: "BEBEK BAKIM", image: "https://images.unsplash.com/photo-1515488042361-ee00e0ddd4e4?w=300&h=200&fit=crop", link: "bebek-bakim" },
    ],
  },
  "ev-yasam": {
    textColumns: [
      {
        title: "Ev Tekstili",
        items: [
          { label: "Nevresim Takimi", value: "nevresim" },
          { label: "Hali & Kilim", value: "hali" },
          { label: "Perde", value: "perde" },
          { label: "Havlu", value: "havlu" },
          { label: "Yastik & Yorgan", value: "yastik" },
          { label: "Battaniye", value: "battaniye" },
          { label: "Pike", value: "pike" },
        ],
      },
      {
        title: "Mutfak",
        items: [
          { label: "Sofra Takimi", value: "sofra" },
          { label: "Mutfak Gerecleri", value: "mutfak" },
          { label: "Tencere Seti", value: "tencere" },
          { label: "Kahvalti Takimi", value: "kahvalti" },
          { label: "Bardak & Kupa", value: "bardak" },
          { label: "Saklama Kabi", value: "saklama" },
          { label: "Bıcak Seti", value: "bicak" },
        ],
      },
      {
        title: "Mobilya & Dekorasyon",
        items: [
          { label: "Mobilya", value: "mobilya" },
          { label: "Aydinlatma", value: "aydinlatma" },
          { label: "Dekoratif Aksesuar", value: "dekorasyon" },
          { label: "Banyo Aksesuarlari", value: "banyo" },
          { label: "Raf & Dolap", value: "raf" },
          { label: "Masa & Sandalye", value: "masa" },
          { label: "Ayna", value: "ayna" },
        ],
      },
    ],
    promoCards: [
      { label: "EV TEKSTILI", image: "https://images.unsplash.com/photo-1522771739844-6a9f6d5f14af?w=300&h=200&fit=crop", link: "nevresim" },
      { label: "MUTFAK GERECLERI", image: "https://images.unsplash.com/photo-1556910103-1c02745aae4d?w=300&h=200&fit=crop", link: "mutfak", highlight: true },
      { label: "MOBILYA", image: "https://images.unsplash.com/photo-1555041469-a586c61ea9bc?w=300&h=200&fit=crop", link: "mobilya" },
      { label: "DEKORASYON", image: "https://images.unsplash.com/photo-1513694203232-719a280e022f?w=300&h=200&fit=crop", link: "dekorasyon" },
    ],
  },
  kozmetik: {
    textColumns: [
      {
        title: "Cilt Bakimi",
        items: [
          { label: "Nemlendirici", value: "nemlendirici" },
          { label: "Gunes Kremi", value: "gunes-kremi" },
          { label: "Serum", value: "serum" },
          { label: "Temizleme Jeli", value: "temizleme" },
          { label: "Tonik", value: "tonik" },
          { label: "Goz Kremi", value: "goz-kremi" },
          { label: "Peeling", value: "peeling" },
          { label: "Maske", value: "maske" },
        ],
      },
      {
        title: "Makyaj",
        items: [
          { label: "Goz Makyaji", value: "goz-makyaji" },
          { label: "Dudak Makyaji", value: "dudak-makyaji" },
          { label: "Fondoten", value: "fondoten" },
          { label: "Oje", value: "oje" },
          { label: "Maskara", value: "maskara" },
          { label: "Ruj", value: "ruj" },
          { label: "Pudra", value: "pudra" },
          { label: "Allik", value: "allik" },
        ],
      },
      {
        title: "Parfum & Sac",
        items: [
          { label: "Kadin Parfum", value: "parfum" },
          { label: "Erkek Parfum", value: "erkek-parfum" },
          { label: "Sac Bakimi", value: "sac-bakimi" },
          { label: "Sac Sekillendirme", value: "sac-sekil" },
          { label: "Deodorant", value: "deodorant" },
          { label: "Dus Jeli", value: "dus-jeli" },
          { label: "Vucut Losyonu", value: "vucut-losyonu" },
          { label: "Epilasyon", value: "epilasyon" },
        ],
      },
    ],
    promoCards: [
      { label: "CILT BAKIMI", image: "https://images.unsplash.com/photo-1556228720-195a672e8a03?w=300&h=200&fit=crop", link: "cilt-bakimi" },
      { label: "PARFUM", image: "https://images.unsplash.com/photo-1541643600914-78b084683601?w=300&h=200&fit=crop", link: "parfum", highlight: true },
      { label: "MAKYAJ", image: "https://images.unsplash.com/photo-1522335789203-aabd1fc54bc9?w=300&h=200&fit=crop", link: "goz-makyaji" },
      { label: "SAC BAKIMI", image: "https://images.unsplash.com/photo-1527799820374-dcf8d9d4a388?w=300&h=200&fit=crop", link: "sac-bakimi" },
    ],
  },
  spor: {
    textColumns: [
      {
        title: "Spor Giyim",
        items: [
          { label: "Esofman", value: "spor-giyim" },
          { label: "Tayt", value: "tayt" },
          { label: "Spor Tisort", value: "spor-tisort" },
          { label: "Spor Ayakkabi", value: "spor-ayakkabi" },
          { label: "Spor Sutyeni", value: "spor-sutyeni" },
          { label: "Yagmurluk", value: "yagmurluk" },
          { label: "Mont & Yelek", value: "spor-mont" },
          { label: "Forma", value: "forma" },
        ],
      },
      {
        title: "Ekipman",
        items: [
          { label: "Fitness Aletleri", value: "fitness" },
          { label: "Yoga & Pilates", value: "yoga" },
          { label: "Kosu Bandı", value: "kosu-bandi" },
          { label: "Dambil & Agirlik", value: "dambil" },
          { label: "Outdoor", value: "outdoor" },
          { label: "Kamp Malzemeleri", value: "kamp" },
          { label: "Bisiklet", value: "bisiklet" },
          { label: "Matara & Shaker", value: "matara" },
        ],
      },
      {
        title: "Markalar",
        items: [
          { label: "Nike", value: "nike" },
          { label: "Adidas", value: "adidas" },
          { label: "Puma", value: "puma" },
          { label: "New Balance", value: "new-balance" },
          { label: "Under Armour", value: "under-armour" },
          { label: "Reebok", value: "reebok" },
          { label: "Asics", value: "asics" },
          { label: "Skechers", value: "skechers" },
        ],
      },
    ],
    promoCards: [
      { label: "SPOR AYAKKABI", image: "https://images.unsplash.com/photo-1542291026-7eec264c27ff?w=300&h=200&fit=crop", link: "spor-ayakkabi" },
      { label: "FITNESS EKIPMANI", image: "https://images.unsplash.com/photo-1534438327276-14e5300c3a48?w=300&h=200&fit=crop", link: "fitness", highlight: true },
      { label: "OUTDOOR", image: "https://images.unsplash.com/photo-1551632811-561732d1e306?w=300&h=200&fit=crop", link: "outdoor" },
      { label: "KAMP MALZEMELERI", image: "https://images.unsplash.com/photo-1504280390367-361c6d9f38f4?w=300&h=200&fit=crop", link: "kamp" },
    ],
  },
};

const NAV_TABS = [
  { id: "kadin", name: "Kadin" },
  { id: "erkek", name: "Erkek" },
  { id: "elektronik", name: "Elektronik" },
  { id: "anne-cocuk", name: "Anne & Cocuk" },
  { id: "ev-yasam", name: "Ev & Yasam" },
  { id: "kozmetik", name: "Kozmetik" },
  { id: "spor", name: "Spor" },
];

export default function Navbar({ isScrolled = false }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [alarmCount, setAlarmCount] = useState(0);
  const [favCount, setFavCount] = useState(0);
  const [activeMenu, setActiveMenu] = useState<string | null>(null);

  const isCategoryPage =
    location.pathname.includes("/category") ||
    location.search.includes("category");

  const fetchCounts = async () => {
    try {
      const { data: { user } } = await supabase.auth.getUser();
      if (user) {
        const [alerts, favs] = await Promise.all([
          supabase.from("price_alerts").select("id", { count: "exact", head: true }).eq("user_id", user.id),
          supabase.from("user_favorites").select("id", { count: "exact", head: true }).eq("user_id", user.id),
        ]);
        setAlarmCount(alerts.count || 0);
        setFavCount(favs.count || 0);
      }
    } catch (error) {
      console.error("Sayac hatasi:", error);
    }
  };

  useEffect(() => {
    fetchCounts();
    window.addEventListener("navbar-update", fetchCounts);
    const channel = supabase
      .channel("navbar-counts")
      .on("postgres_changes", { event: "*", schema: "public", table: "user_favorites" }, () => fetchCounts())
      .on("postgres_changes", { event: "*", schema: "public", table: "price_alerts" }, () => fetchCounts())
      .subscribe();
    return () => {
      window.removeEventListener("navbar-update", fetchCounts);
      supabase.removeChannel(channel);
    };
  }, []);

  const handleProfileClick = async () => {
    try {
      const { data: { user } } = await supabase.auth.getUser();
      if (user) {
        navigate("/profile");
      } else {
        navigate("/login");
      }
    } catch {
      navigate("/login");
    }
  };

  const finalColor = "#ffffff";
  const finalBg = "#111111";
  const menuData = activeMenu ? MEGA_MENU_DATA[activeMenu] : null;

  return (
    <>
      <nav
        className="fixed top-0 left-0 w-full h-16 transition-all duration-300 shadow-xl border-b border-white/10"
        style={{ zIndex: 99999, backgroundColor: finalBg, pointerEvents: "none" }}
      >
        <div className="max-w-[1440px] mx-auto px-4 lg:px-8 h-16 flex items-center justify-between pointer-events-auto">
          <div className="flex items-center h-full gap-6">
            <Link to="/" className="bg-rose-600 px-3.5 py-1.5 rounded-xl italic font-black text-white text-lg tracking-tighter shrink-0 hover:bg-rose-500 transition-all shadow-md shadow-rose-600/30">
              OUTLETLIO
            </Link>
            <div className="hidden lg:flex items-center h-full">
              {NAV_TABS.map((tab) => (
                <div
                  key={tab.id}
                  className="relative h-full flex items-center"
                  onMouseEnter={() => setActiveMenu(tab.id)}
                  onMouseLeave={() => setActiveMenu(null)}
                >
                  <Link
                    to={`/?category=${tab.id}`}
                    className={`px-3 xl:px-4 h-full font-bold text-xs xl:text-sm tracking-wide transition-colors uppercase flex items-center text-gray-200 hover:!text-rose-500 ${activeMenu === tab.id ? "!text-rose-500" : ""}`}
                  >
                    {tab.name}
                  </Link>
                  {activeMenu === tab.id && (
                    <div className="absolute bottom-0 left-0 w-full h-[3px] bg-rose-500 shadow-[0_0_10px_rgba(244,63,94,0.8)]" />
                  )}
                </div>
              ))}
            </div>
          </div>

          <div className="flex items-center gap-3 shrink-0">
            {/* Fiyat Alarmları */}
            <Link 
              to="/alarms" 
              title="Fiyat Alarmları"
              className="relative p-2.5 rounded-full text-gray-300 hover:text-white hover:bg-white/10 transition-all active:scale-90 flex items-center justify-center"
            >
              <i className="ri-notification-3-line text-2xl"></i>
              {alarmCount > 0 && (
                <span className="absolute top-1 right-1 bg-rose-600 text-white text-[10px] min-w-4 h-4 px-1 rounded-full flex items-center justify-center font-bold border-2 border-[#111111] animate-pulse">
                  {alarmCount}
                </span>
              )}
            </Link>

            {/* Favoriler / Beğeniler */}
            <Link 
              to="/favorites" 
              title="Favorilerim"
              className="relative p-2.5 rounded-full text-gray-300 hover:text-white hover:bg-white/10 transition-all active:scale-90 flex items-center justify-center"
            >
              <i className="ri-heart-3-line text-2xl"></i>
              {favCount > 0 && (
                <span className="absolute top-1 right-1 bg-rose-600 text-white text-[10px] min-w-4 h-4 px-1 rounded-full flex items-center justify-center font-bold border-2 border-[#111111] animate-pulse">
                  {favCount}
                </span>
              )}
            </Link>

            {/* Profil / Giriş Butonu */}
            <button 
              type="button"
              onClick={handleProfileClick} 
              title="Hesabım"
              className="w-10 h-10 rounded-full bg-gradient-to-tr from-gray-800 to-gray-700 flex items-center justify-center cursor-pointer hover:from-rose-600 hover:to-rose-500 transition-all border border-gray-600 text-white active:scale-90 shadow-sm"
            >
              <i className="ri-user-smile-line text-xl"></i>
            </button>
          </div>
        </div>
      </nav>

      {/* MEGA MENU DROPDOWN */}
      {activeMenu && menuData && (
        <div
          className="fixed left-0 w-full bg-[#111111] text-white shadow-2xl border-t-[3px] border-rose-600 pointer-events-auto"
          style={{ zIndex: 99998, top: "64px" }}
          onMouseEnter={() => setActiveMenu(activeMenu)}
          onMouseLeave={() => setActiveMenu(null)}
        >
          <div className="max-w-[1440px] mx-auto px-4 lg:px-8 py-8">
            <div className="flex gap-8">
              {/* SOL: Metin Link Sutunlari */}
              <div className="flex-1 grid grid-cols-3 gap-8">
                {menuData.textColumns.map((col: any, idx: number) => (
                  <div key={idx}>
                    <h4 className="text-rose-400 font-black text-xs uppercase tracking-[0.15em] mb-4 flex items-center gap-2">
                      <span className="w-1 h-4 bg-rose-500 rounded-full"></span>
                      {col.title}
                    </h4>
                    <ul className="space-y-1.5">
                      {col.items.map((item: any, i: number) => (
                        <li key={i}>
                          <Link
                            to={`/?category=${item.value}`}
                            onClick={() => setActiveMenu(null)}
                            className="text-[13px] text-gray-400 hover:text-white transition-all block py-0.5 hover:translate-x-1 duration-200"
                          >
                            {item.label}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>

              {/* SAG: Gorsel Promo Kartlari */}
              <div className="w-[400px] shrink-0">
                <div className={`grid grid-cols-2 gap-3 ${menuData.promoCards.length > 4 ? "grid-rows-3" : "grid-rows-2"}`}>
                  {menuData.promoCards.map((card: any, idx: number) => (
                    <Link
                      key={idx}
                      to={`/?category=${card.link}`}
                      onClick={() => setActiveMenu(null)}
                      className={`relative rounded-xl overflow-hidden group cursor-pointer ${card.highlight ? "col-span-2 h-28" : "h-24"}`}
                    >
                      <img src={card.image} alt={card.label} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />
                      <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent" />
                      <div className="absolute bottom-0 left-0 p-3">
                        <span className="text-white font-black text-[11px] uppercase tracking-wider drop-shadow-lg">{card.label}</span>
                        <span className="ml-2 text-rose-400 text-[10px] font-bold">&rsaquo;</span>
                      </div>
                    </Link>
                  ))}
                </div>
              </div>
            </div>

            {/* ALT: Tum kategoriler baglantisi */}
            <div className="mt-6 pt-4 border-t border-gray-800 flex items-center justify-between">
              <Link
                to={`/?category=${activeMenu}`}
                onClick={() => setActiveMenu(null)}
                className="text-xs font-bold text-gray-400 hover:text-white transition-colors flex items-center gap-1 cursor-pointer"
              >
                <span>Tum {menuData.textColumns[0]?.title} & Diger Urunleri Gor</span>
                <i className="ri-arrow-right-line text-rose-500"></i>
              </Link>
              <span className="text-gray-600 text-[10px] uppercase tracking-widest font-bold">OUTLETLIO.COM</span>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
